/* eslint-disable no-param-reassign */
/* global G */
import { curry, pipe } from 'lib/util'
import appModuleComposition from 'trait/composition/appmodule'
import { usesGetterSetter } from 'trait/uses'
import { canHookInto } from 'trait/can'
import { withGetterSetter } from 'trait/with'
import actions from './actions'
import hooks from './hooks'
import events from './events'

const descriptor = 'module::admin'

const composition = pipe(
  appModuleComposition(descriptor),
  withGetterSetter(G.PARENT),
  usesGetterSetter(G.ACTIONS, actions),
  usesGetterSetter(G.EVENTS, events),
  canHookInto(G.ACTIONS, hooks),
)

export default composition
